export default {"src":"/_next/static/media/AFRM.92721aee.svg","height":18,"width":18};